const BOARD_DATA_BASE_URL = 'https://abet-board-data.abetco.workers.dev'
export const BOARD_RELEASE_STALE_AFTER_MS = 15 * 60_000

export async function fetchBoardReleaseManifest() {
  const response = await fetch(`${BOARD_DATA_BASE_URL}/data/release_manifest.json`, {
    cache: 'no-store',
    signal: AbortSignal.timeout(10_000),
  })
  if (!response.ok) throw new Error(`Board release unavailable (HTTP ${response.status})`)
  return response.json()
}

export function classifyBoardRelease(manifest, nowMs = Date.now(), staleAfterMs = BOARD_RELEASE_STALE_AFTER_MS) {
  const capturedMs = Date.parse(manifest?.captured_utc || '')
  if (!Number.isFinite(capturedMs)) {
    return { state: 'unavailable', capturedAt: null, ageMs: null, releaseId: manifest?.release_id || null }
  }
  const ageMs = Math.max(0, nowMs - capturedMs)
  return {
    state: ageMs <= staleAfterMs ? 'current' : 'stale',
    capturedAt: manifest.captured_utc,
    ageMs,
    releaseId: manifest.release_id || null,
    books: Number(manifest?.counts?.game_line_books || 0),
    rows: Number(manifest?.counts?.game_line_rows || 0),
  }
}
